var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHlpAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1 6.45C22 6.17 21.85 5.91 21.65 5.69C21.43 5.45 21.17 5.3 20.78 5.09L12.44 0.450005C12.07 0.250005 11.83 0.120005 11.52 0.0500049C11.24 -0.00999512 10.96 -0.00999512 10.68 0.0500049C10.37 0.120005 10.13 0.250005 9.76 0.450005L1.42 5.08C1.03 5.29 0.77 5.44 0.55 5.68C0.34 5.9 0.2 6.16 0.1 6.44C0 6.76 0 7.05 0 7.49V16.64C0 17.09 0 17.38 0.1 17.69C0.19 17.97 0.35 18.23 0.55 18.45C0.77 18.7 1.03 18.84 1.41 19.05L9.76 23.69C10.13 23.89 10.37 24.03 10.68 24.09C10.82 24.12 10.96 24.13 11.1 24.13C11.24 24.13 11.38 24.12 11.52 24.09C11.83 24.03 12.07 23.89 12.44 23.69L20.79 19.05C21.17 18.84 21.43 18.7 21.65 18.45C21.85 18.24 22 17.97 22.1 17.69C22.2 17.38 22.2 17.09 22.2 16.64V7.5C22.2 7.06 22.2 6.77 22.1 6.45ZM11.11 18.67C10.59 18.67 10.16 18.24 10.16 17.72C10.16 17.2 10.57 16.77 11.1 16.77H11.11C11.64 16.77 12.06 17.19 12.06 17.72C12.06 18.25 11.64 18.67 11.11 18.67ZM11.31 14.11C11.21 14.14 11.11 14.15 11.01 14.15C10.61 14.15 10.24 13.9 10.11 13.51C9.94 13.01 10.21 12.47 10.71 12.3C11.42 12.06 13.44 11.09 13.44 9.82C13.44 9.25 13.24 8.69 12.87 8.25C12.5 7.81 11.99 7.51 11.42 7.42C10.85 7.32 10.27 7.43 9.78 7.72C9.28 8.01 8.9 8.47 8.71 9.01C8.54 9.50001 8 9.77 7.5 9.59C7.01 9.41 6.75 8.87 6.92 8.38C7.26 7.41 7.93 6.6 8.81 6.08C9.69 5.56 10.74 5.37 11.74 5.54C12.75 5.72 13.67 6.24 14.32 7.02C14.98 7.81 15.34 8.8 15.34 9.82C15.34 12.73 11.47 14.05 11.31 14.11Z",
    fill: "url(#paint0_linear_21_237)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_237",
    x1: 0,
    y1: 12.07,
    x2: 22.2,
    y2: 12.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 24.14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlpAct1);
export default __webpack_public_path__ + "static/media/HlpAct_1.1c01a5632ce4855eeab6dc24326878dd.svg";
export { ForwardRef as ReactComponent };